import { createTheme } from "@mui/material/styles";
import merge from "lodash.merge";
import { theme as immatTheme } from "./immatTheme";
import { theme as proTheme } from "./proTheme";

export const theme = merge({}, immatTheme, proTheme, {});

export default createTheme(theme);
